import {
  WEBVIEW_USER_AGENT,
  VERSION_USER_AGENT,
  CHROME_USER_AGENT,
  ANDROID_WEBVIEW_USER_AGENT,
  STANDALONE_USER_AGENT,
} from '../constants/TWA/twaAccess';

const detectTWAAccess = () => {
  const { userAgent } = navigator;

  const isTWA =
    userAgent.includes(WEBVIEW_USER_AGENT) ||
    (userAgent.includes(VERSION_USER_AGENT) && userAgent.includes(CHROME_USER_AGENT)) ||
    userAgent.match(ANDROID_WEBVIEW_USER_AGENT) ||
    (document.referrer === '' && window.matchMedia(STANDALONE_USER_AGENT).matches);

  return Boolean(isTWA);
};

export default detectTWAAccess;
